@import '../../../globals/main.scss';
@import './pn-proxio-pricegroup-common.scss';

pn-proxio-pricegroup {
  div.proxio-pricegroup-container {
    max-width: 99.4rem;
  }

  div.weightcontainer {
    margin: 2.8rem 0;
  }

  div.weightvaluecontainer {
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: space-between;
    align-items: flex-start;

    pn-button {
      transform: translateY(-0.4rem);

      button::before {
        display: none;
      }
    }
  }

  div.weightradios {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    color: $blue700;
    width: 80%;
    margin: 0 3.6rem;
    position: relative;
    width: 0%;

    &[data-carousel-container-position='end50'] {
      width: 45%;
      margin-left: auto;
      margin-right: 3.6rem;

      @media screen and (max-width: $productcard-media-tablet) {
        width: 40%;
      }
    }

    &[data-carousel-container-position='end75'] {
      width: 65%;
      margin-left: auto;
      margin-right: 3.6rem;

      @media screen and (max-width: $productcard-media-tablet) {
        margin-right: auto;
      }
    }

    &[data-carousel-container-position='start50'] {
      width: 45%;
      margin-right: auto;
      margin-left: 3.6rem;

      @media screen and (max-width: $productcard-media-tablet) {
        width: 40%;
      }
    }

    &[data-carousel-container-position='start75'] {
      width: 65%;
      margin-right: auto;
      margin-left: 3.6rem;

      @media screen and (max-width: $productcard-media-tablet) {
        margin-left: auto;
      }
    }

    &[data-carousel-container-position='default'] {
      flex: 0 0 auto;
      width: 80%;

      @media screen and (max-width: $productcard-media-tablet) {
        width: 65%;
      }
    }
  }

  div.weightdata {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 1.2rem;
    min-width: 4rem;
    cursor: pointer;

    label {
      font-size: 1.4rem;
      cursor: pointer;
    }

    &[data-carousel-position='0'] {
      font-size: 2rem;
      font-weight: 700;
    }

    &[data-carousel-position='2'],
    &[data-carousel-position='-2'] {
      @media screen and (max-width: $productcard-media-tablet) {
        display: none;
      }
    }

    &[data-carousel-position='outside'] {
      display: none;
    }

    input[type='radio'] {
      -webkit-appearance: none;
      -moz-appearance: none;
      width: 1.2rem;
      height: 1.2rem;
      background-color: $blue700;
      border-radius: 50%;
      margin: 0;
      cursor: pointer;
    }

    input[type='radio']:checked {
      z-index: 1;
      transform: translateY(-0.1rem);
      height: 1.4rem;
      width: 1.4rem;
      box-shadow:
        0 0 0 0.3rem $white,
        0 0 0 0.4rem $blue700;
    }
  }

  div.weightline {
    width: 100%;
    background-color: $gray50;
    z-index: -1;
    height: 0.8rem;
    -webkit-transform: translateX(2.1rem) translateY(1.32rem);
    transform: translateX(2.1rem) translateY(1rem);
    border-radius: 2rem;
    margin-right: 3.5rem;
  }

  pn-button {
    &[disabled='disabled'] {
      opacity: 0.2;

      button {
        cursor: default;

        &.pn-button-light .pn-button-bg:after {
          background-color: $white;
        }

        &[data-tooltip-open]:before {
          display: none;
        }
      }
    }

    button div.button-tooltip {
      display: none;
    }

    button:focus .pn-button-bg {
      box-shadow: none;
    }
  }
}
